export default __webpack_public_path__ + "static/media/ic_practice.b9e79618.svg";